import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="bg-[#ECEEF1] py-16 sm:py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl mb-12">
          <span className="text-xs uppercase tracking-widest font-semibold text-[#5A232E] block mb-2">
            Juridisk information
          </span>
          <h1 className="font-display text-4xl sm:text-5xl text-[#5A232E] tracking-tight">
            Privatlivspolitik
          </h1>
          <p className="mt-3 text-sm sm:text-base text-[#6c7480]">
            Psykoterapeut Kim Palasz · CVR: 36149914 · Marengovej 2, 2300 København S
          </p>
        </div>

        {/* Content Body */}
        <div className="bg-white rounded-3xl p-8 sm:p-12 border border-[#D9DDE2] shadow-xs space-y-8 text-[#11161d] leading-relaxed text-sm sm:text-base">
          <div className="space-y-4 pb-6 border-b border-[#D9DDE2]">
            <p>
              Den 25. maj 2018 trådte EU’s persondataforordning i kraft. I den forbindelse er reglerne blevet skærpet med hensyn til underretning om, hvilke persondata, der behandles hos psykologer og psykoterapeuter.
            </p>
            <p>
              Psykoterapeut Kim Palasz er certificeret psykoterapeut, supervisor og coach, godkendt som medlem af Dansk Psykoterapeut Forening (MPF). Formålet med behandlingen er at yde psykoterapi.
            </p>
            <p>
              Oplysninger, som noteres/registreres om klienten er for at sikre kontinuitet i behandlingen og for at kunne yde den bedst mulige behandling tages der, efter hver session med klienten, kortfattede notater om emner/problematikker - evt. diagnose - og behandlingsmetode – herunder de anvendte psykoterapeutiske redskaber.
            </p>
          </div>

          {/* 1. Dataansvarlig */}
          <div className="space-y-3">
            <h2 className="font-display text-2xl text-[#5A232E]">1. Dataansvarlig</h2>
            <div className="p-4 rounded-xl bg-[#ECEEF1] border border-[#D9DDE2] text-sm space-y-1">
              <p><strong>Navn:</strong> Psykoterapeut Kim Palasz</p>
              <p><strong>Adresse:</strong> Marengovej 2, 2300 København S</p>
              <p><strong>CVR-nr.:</strong> 36149914</p>
              <p><strong>Kontakt:</strong> <a href="mailto:kontakt@palasz.dk" className="text-[#5A232E] underline">kontakt@palasz.dk</a></p>
            </div>
          </div>

          {/* 2. Formål & behandlingsaktiviteter */}
          <div className="space-y-3">
            <h2 className="font-display text-2xl text-[#5A232E]">2. Formål & behandlingsaktiviteter</h2>
            <p>Jeg indsamler og behandler kun personoplysninger, der er nødvendige for:</p>
            <ul className="list-disc list-inside space-y-1 text-[#6c7480] pl-2">
              <li>Besvarelse af henvendelser fra potentielle klienter</li>
              <li>Booking og administration af sessioner</li>
              <li>Kommunikation (mail, telefon, sms)</li>
              <li>Fakturering og økonomisk administration</li>
              <li>Kvalitetssikring og journalskrivning</li>
              <li>Overholdelse af lovgivning og faglige standarder</li>
            </ul>
          </div>

          {/* 3. Hvilke oplysninger jeg behandler */}
          <div className="space-y-3">
            <h2 className="font-display text-2xl text-[#5A232E]">3. Hvilke oplysninger jeg behandler</h2>
            <p>Typisk indsamlet data omfatter:</p>
            <ul className="list-disc list-inside space-y-1 text-[#6c7480] pl-2">
              <li>Personlige data (navn, fødselsdato, adresse)</li>
              <li>Kontaktoplysninger (mail, telefon)</li>
              <li>Journaldata og behandlingsnotater</li>
              <li>Betalings- og forsikringsdata (ikke kreditkortinfo)</li>
              <li>Samtykker og beslutninger om behandling</li>
              <li>Helbredsoplysninger (særligt følsomme oplysninger)</li>
            </ul>
          </div>

          {/* 4. Retsgrundlag for behandling */}
          <div className="space-y-3">
            <h2 className="font-display text-2xl text-[#5A232E]">4. Retsgrundlag for behandling</h2>
            <p>Behandling sker i overensstemmelse med GDPR-artikel 6 og 9.</p>
            <ul className="list-disc list-inside space-y-1 text-[#6c7480] pl-2">
              <li>Samtykke fra dig (fx til mailkommunikation)</li>
              <li>Opfyldelse af aftale (terapisessioner)</li>
              <li>Juridiske forpligtelser (journallov)</li>
            </ul>
          </div>

          {/* 5. Opbevaringsperiode */}
          <div className="space-y-3">
            <h2 className="font-display text-2xl text-[#5A232E]">5. Opbevaringsperiode</h2>
            <p>
              Journaldata slettes efter gældende journalpligt, medmindre andet er påkrævet ifølge lovgivning. Du kan til enhver tid kontakte mig, hvis du ønsker at få slettet oplysninger, i det omfang det er lovligt muligt.
            </p>
            <ul className="list-disc list-inside space-y-1 text-[#6c7480] pl-2">
              <li>Sessionsdata og journaler: minimum 5 år efter sidste kontakt</li>
              <li>Økonomiske data: efter bogføringslov</li>
              <li>Kommunikations- og bookingoplysninger: op til 2 år</li>
            </ul>
          </div>

          {/* 6. Videregivelse og registrering */}
          <div className="space-y-3">
            <h2 className="font-display text-2xl text-[#5A232E]">6. Videregivelse og registrering</h2>
            <p>
              Jeg anvender databehandlere (fx bookingsystem, mailtjeneste), som opfylder kravene i databeskyttelsesforordningen og har indgået databehandleraftaler med disse.
            </p>
            <ul className="list-disc list-inside space-y-1 text-[#6c7480] pl-2">
              <li>Ingen persondata deles med tredjepart uden dit samtykke.</li>
              <li>Legitime videregivelser: f.eks. revisionsfirma, betalingstjeneste, myndigheder.</li>
              <li>Ingen automatisk profilering eller deling med reklameselskaber.</li>
            </ul>
            <p className="mt-3">
              Som psykoterapeut har jeg tavshedspligt. Det betyder, at det er strafbart uberettiget at videregive eller udnytte fortrolige oplysninger fra dine samtaler. Oplysninger, der videregives, skal derfor først godkendes af dig.
            </p>
            <p className="mt-2 text-xs sm:text-sm text-[#6c7480]">
              Der er enkelte undtagelser til min tavshedspligt. Hvis der foreligger åbenbar og akut fare for dig eller andre, skal jeg informere relevante andre herom. Jeg har således pligt til at forebygge skade. Jeg har desuden skærpet pligt til at underrette kommunen, hvis jeg får kendskab til eller grund til at antage, at et barn eller en ung under 18 år udsættes for omsorgssvigt eller på anden vis er truet på sin trivsel og udvikling.
            </p>
          </div>

          {/* 7. Dine rettigheder */}
          <div className="space-y-3">
            <h2 className="font-display text-2xl text-[#5A232E]">7. Dine rettigheder</h2>
            <p>Du har ret til at:</p>
            <ul className="list-disc list-inside space-y-1 text-[#6c7480] pl-2">
              <li>Få indsigt i dine data</li>
              <li>Bedre rettelser, sletning eller begrænsning</li>
              <li>Indsigelse mod behandling</li>
              <li>Dataportabilitet</li>
              <li>Trække dit samtykke tilbage</li>
            </ul>
            <p className="mt-2">
              Kontakt mig via mail for at udøve disse rettigheder.
            </p>
            <p className="mt-1 text-xs text-[#6c7480]">
              Hvis du har klager over min behandling af dine persondata, har du ret til at indgive klage til Datatilsynet via <a href="https://www.datatilsynet.dk" target="_blank" rel="noopener noreferrer" className="text-[#5A232E] underline">www.datatilsynet.dk</a>.
            </p>
          </div>

          {/* 8. Sikkerhed og databeskyttelse */}
          <div className="space-y-3">
            <h2 className="font-display text-2xl text-[#5A232E]">8. Sikkerhed og databeskyttelse</h2>
            <p>Jeg opbevarer data sikkert:</p>
            <ul className="list-disc list-inside space-y-1 text-[#6c7480] pl-2">
              <li>Krypteret elektronisk opbevaring</li>
              <li>Adgangskodebeskyttelse og sikker backup</li>
              <li>Fysisk beskyttelse af eventuelle papirdokumenter</li>
            </ul>
          </div>

          {/* 9. Brug af cookies */}
          <div className="space-y-3">
            <h2 className="font-display text-2xl text-[#5A232E]">9. Brug af cookies</h2>
            <p>
              Din browsing kan registreres via cookies/statistik (Google Analytics). Ingen personfølsomme oplysninger deles. Du kan vælge at slå cookies fra i din browser.
            </p>
          </div>

          {/* 10. Ændringer i politikken */}
          <div className="space-y-3">
            <h2 className="font-display text-2xl text-[#5A232E]">10. Ændringer i politikken</h2>
            <p>
              Eventuelle opdateringer vil blive offentliggjort her. Ved større ændringer (fx nyt databehandlingsformål) gives der besked via mail eller på hjemmesiden.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
